export interface MetricCounters {
  spend: number; impressions: number; clicks: number; leads: number;
  purchases: number; registrations: number; app_installs: number;
}
export function emptyCounters(): MetricCounters {
  return { spend: 0, impressions: 0, clicks: 0, leads: 0, purchases: 0, registrations: 0, app_installs: 0 };
}
type Derived<T> = { cpm:T; cpc:T; ctr:T; cost_per_lead:T; cost_per_purchase:T; cost_per_registration:T; cost_per_app_install:T };
export function derivedMetrics(c: MetricCounters, mode: 'report'): Derived<number>;
export function derivedMetrics(c: MetricCounters, mode: 'automation'): Derived<number|null>;
export function derivedMetrics(c: MetricCounters, mode: 'report' | 'automation') {
  const ratio = (denominator: number, scale = 1) => Number.isFinite(c.spend) && Number.isFinite(denominator) && denominator > 0 ? c.spend / denominator * scale : mode === 'report' ? 0 : null;
  return { cpm: ratio(c.impressions, 1000), cpc: ratio(c.clicks),
    ctr: Number.isFinite(c.clicks) && Number.isFinite(c.impressions) && c.impressions > 0 ? c.clicks / c.impressions * 100 : mode === 'report' ? 0 : null,
    cost_per_lead: ratio(c.leads), cost_per_purchase: ratio(c.purchases),
    cost_per_registration: ratio(c.registrations), cost_per_app_install: ratio(c.app_installs) };
}
